import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { MoneyEntitlementService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import ToastComponent from '../../components/toast';

const usePutMoneyEntitlements = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<unknown, unknown, any, unknown> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload?: Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto[]) => {
      return await handleRequest(
        MoneyEntitlementService.putApiAwardSettlementApiMoneyEntitlements(payload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null && response?.isSuccess) {
          await queryClient.invalidateQueries('getMoneyEntitlementExistingSetup');
          toast.success(
            <ToastComponent label='Success' message='Money transfer type updated successfully.' />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePutMoneyEntitlements;
